"use client";
import {useState, useEffect} from "react";
import Grid from "@mui/material/Grid2";
import {Box, Button, Card, CardActions, CardContent, CardMedia, IconButton, Typography, Modal, Stack} from "@mui/material";
import {formatPrice} from "../../utils";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import DeleteIcon from "@mui/icons-material/Delete";
import { SecurityUtils } from "pp-web";
import { isPostHogActive } from "utils";
import { usePostHog } from "posthog-js/react";
import { FaStar } from "react-icons/fa";
import bestSellerBadge from "../../assets/img/best-seller_7251267.png"
import badge from "../../assets/img/seller-badge.png"
import img1 from "../../assets/img/how_to_get_deal/s1.jpg"
import img2 from "../../assets/img/how_to_get_deal/s2.jpg"
import img3 from "../../assets/img/how_to_get_deal/s3.jpg"
import { useMediaQuery } from '@mui/material';


export default function Deal(props) {
    const {deal, user, categories = [], setQuestionaireModal, updateRecommendation, deleteDeal, setOpenModal, setSelectedDeal} = props
    const hasKeepa = deal?.promoCode?.toUpperCase().includes('KEEPA');
    let [readMore, setReadMore] = useState("");

    const posthog = usePostHog();
    const dealTime = formatDealTime(deal?.validTill);
    const isMobile = useMediaQuery('(max-width:1023px)');

    const handleGetDeal = () => {
        if(isPostHogActive()) {
            posthog.capture("get_deal_click", {
                dealId: deal.productId,
                category: deal.category
            });
        }
        const modalPreference = localStorage.getItem('dealModalPreference');
        if (modalPreference !== 'true') {
            setSelectedDeal(deal);
            setOpenModal(true);
        } else {
            window.open(deal?.url, '_blank', 'noopener,noreferrer');
        }
    };

    function truncateWithReadMore(text, limit) {
        if (!text || text?.length <= limit) return text;
        return (
            <>
                {readMore === text ? (
                    <>
                        {text}{" "}
                        <b
                            style={{color: 'black', cursor: 'pointer'}}
                            onClick={() => setReadMore("")}
                        >
                            Read Less
                        </b>
                    </>
                ) : (
                    <>
                        {text.slice(0, limit)}...{" "}
                        <b
                            style={{color: 'black', cursor: 'pointer'}}
                            onClick={() => setReadMore(text)}
                        >
                            Read More
                        </b>
                    </>
                )}
            </>
        );
    }

    function formatDealTime(isoDate) {
        const date = new Date(isoDate);
        const now = new Date();
        const diffInHours = (date - now) / (1000 * 60 * 60);

        if (diffInHours < 24) {
            const hours = Math.floor(diffInHours);
            const minutes = Math.floor((diffInHours - hours) * 60);
            return {
                text: "ends soon in",
                time: `${hours}h ${minutes}m`
            };
        }

        return {
            text: "valid through",
            time: new Intl.DateTimeFormat('en-GB', {day: '2-digit', month: 'short', year: 'numeric'}).format(date)
        };
    }


    return (
        <>
            <Grid size={{xs: 12, sm: 6, md: 3, lg: 3, xl: 2}} className="user-deal-item">
                <Card sx={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    boxShadow: "none",
                    border: "none",
                    position: "relative",
                    borderRadius: "10px",
                    transition: "transform 0.2s ease-in-out",
                    "&:hover": {
                        transform: "translateY(-8px) scale(1.02)",
                        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)"
                    }
                }}>
                    {/* Triangular Badge */}
                    {/*{deal.percentage && (*/}
                    {/*    <Box*/}
                    {/*        sx={{*/}
                    {/*            position: "absolute",*/}
                    {/*            top: 0,*/}
                    {/*            right: 0,*/}
                    {/*            width: 0,*/}
                    {/*            height: 0,*/}
                    {/*            borderStyle: "solid",*/}
                    {/*            borderWidth: "0 90px 90px 0",*/}
                    {/*            borderColor: `transparent var(--theme-dark) transparent transparent`,*/}
                    {/*            zIndex: 1,*/}
                    {/*        }}*/}
                    {/*    >*/}
                    {/*        <Typography*/}
                    {/*            sx={{*/}
                    {/*                position: "absolute",*/}
                    {/*                top: 50,*/}
                    {/*                right: -90,*/}
                    {/*                transform: "rotate(45deg)",*/}
                    {/*                transformOrigin: "top right",*/}
                    {/*                color: "white",*/}
                    {/*                whiteSpace: "nowrap",*/}
                    {/*                fontWeight: "bold",*/}
                    {/*                fontSize: "1rem",*/}
                    {/*            }}*/}
                    {/*        >*/}
                    {/*            <span style={{color: "white"}}>{deal.percentage}%</span> OFF*/}
                    {/*        </Typography>*/}
                    {/*    </Box>*/}
                    {/*)}*/}

                    {/* keeps badge */}
                    {/*{!hasKeepa && (*/}
                    {/*    <Box*/}
                    {/*        sx={{*/}
                    {/*            position: "absolute",*/}
                    {/*            top: 8,*/}
                    {/*            left: 8,*/}
                    {/*            backgroundColor: "red",*/}
                    {/*            color: "white",*/}
                    {/*            padding: "2px 8px",*/}
                    {/*            borderRadius: "4px",*/}
                    {/*            fontSize: "0.75rem",*/}
                    {/*            fontWeight: "bold",*/}
                    {/*            zIndex: 2,*/}
                    {/*        }}*/}
                    {/*    >*/}
                    {/*        KEEPA DEAL*/}
                    {/*    </Box>*/}
                    {/*)}*/}
                    <CardMedia
                        component="img"
                        image={deal.image}
                        alt={deal.title}
                        sx={{
                            objectFit: "contain",
                            height: "200px",
                            width: "100%",
                            backgroundColor: "#f5f5f5",
                            padding: "8px"
                        }}
                    />

                    <CardContent sx={{flexGrow: 1, py: 1}}>
                        {
                            (deal && deal?.bestSellerRank < 1000) &&
                            <div class="d-flex justify-content-start align-items-center mb-2">
                                {/*<img src={badge.src} alt="best-seller-badge" style={{width: '35px', height: '35px', marginRight: '10px'}}/>*/}
                                <img src={bestSellerBadge.src} alt="best-seller-badge" style={{width: '40px', height: '35px'}}/>
                            </div>
                        }
                        <Typography
                            variant="h6"
                            sx={{
                                fontSize: "16px",
                                minHeight: "35px",
                            }}
                        >
                            <span style={{ color: 'red', fontWeight: 600, fontSize: '17px' }}>{deal.percentage}% OFF</span>
                            {!hasKeepa && (
                                <>
                                    <span style={{ margin: '0 8px', color: '#000' }}>|</span>
                                    <span
                                        style={{
                                            backgroundColor: '#d4f7dc',
                                            color: 'rgb(76, 171, 12)',
                                            padding: '1px 6px',
                                            borderRadius: '4px',
                                            fontWeight: 600,
                                            fontSize: '13.8px'
                                        }}
                                    >
                                        PROMO CODE
                                    </span>
                                </>
                            )}
                        </Typography>
                        <Typography
                            variant="h6"
                            sx={{
                                fontSize: "16px",
                                minHeight: "40px"
                            }}
                        >
                            {truncateWithReadMore(deal.title, 60)}
                        </Typography>
                        <Typography variant="h5" sx={{fontWeight: "bold", color: "red", my: 0.5}}>
                            {formatPrice(deal.discountedPrice)}{" "}
                            <Typography component="span"
                                        sx={{textDecoration: "line-through", color: "text.secondary"}}>
                                <b>{formatPrice(deal.price)}</b>
                            </Typography>
                        </Typography>
                        <div class="d-flex justify-content-left align-items-center gap-1 mb-1">
                            <FaStar style={{color: 'FF9529'}}/>
                            <b>{deal?.ratingStars?.toFixed(1)}</b>
                            <span style={{fontSize: '80%'}}>({deal?.ratingCount?.toLocaleString()})</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <Typography
                                variant="subtitle2"
                                color="textSecondary"
                                sx={{
                                    fontSize: "14px",
                                    color: "black"
                                }}
                            >
                                {dealTime.text}
                            </Typography>
                            <Typography
                                variant="subtitle2"
                                color="textSecondary"
                            >
                                <b style={{
                                    color: "black",
                                    fontSize: "16px"
                                }}>{dealTime.time}</b>
                            </Typography>
                        </div>
                        {categories.includes(deal.category) && <Typography
                            sx={{
                                fontSize: "13px",
                                color: "#555",
                                fontStyle: "italic",
                                mt: 0.5
                            }}>
                            Because you're interested in <b>{deal.category}</b>
                            <span
                                onClick={() => setQuestionaireModal(true)}
                                style={{
                                    color: "black",
                                    fontStyle: "normal",
                                    fontWeight: "bold",
                                    fontSize: "12px",
                                    cursor: 'pointer',
                                    paddingLeft: '3px'
                                }}>(Edit)</span>
                        </Typography>}
                    </CardContent>
                    <CardActions sx={{padding: "4px 8px", display: "flex", justifyContent: "space-between"}}>
                        <Button
                            onClick={handleGetDeal}
                            variant="contained"
                            sx={{
                                fontWeight: "bold",
                                textTransform: "none",
                                minWidth: 50,
                                maxWidth: 100,
                                px: 2,
                                textDecoration: "none",
                                color: "white",
                                backgroundColor: "var(--theme-dark)",
                                marginBottom: '8px',
                                "&:hover": {
                                    backgroundColor: "var(--second-color)",
                                    color: "white"
                                }
                            }}
                        >
                            Get Deal
                        </Button>

                        {SecurityUtils.hasRole(user, 'Admin') && <Box>
                            <IconButton
                                onClick={() => updateRecommendation(deal.productId, deal.promoCode, !deal.isRecommended)}
                                color="primary">
                                {deal.isRecommended ? <FavoriteIcon color="warning"/> :
                                    <FavoriteBorderIcon color="warning"/>}
                            </IconButton>


                            <IconButton onClick={() => deleteDeal(deal.productId, deal.promoCode)} color="error">
                                <DeleteIcon/>
                            </IconButton>
                        </Box>}
                    </CardActions>
                </Card>
            </Grid>
        </>
    );
}
